<div class="chatbot-container">
  <!-- Floating Button -->
  <button
    class="chatbot-button"
    (click)="toggleWidget()"
    [@slideIn]="buttonState"
    [@rotate]="isWidgetOpen ? 'open' : 'closed'"
    [class.active]="isWidgetOpen"
    aria-label="Open Assistant">
    <span class="button-icon">{{ isWidgetOpen ? '✕' : '💬' }}</span>
  </button>

  <!-- Unified Chat Widget -->
  <div class="chatbot-widget-wrapper" *ngIf="isWidgetOpen">
    <app-chatbot-widget (widgetClosed)="widgetClosed()"></app-chatbot-widget>
  </div>
</div>
